<h1>
  Stats for {{ labels?.customer_plural | titlecase }} Served from {{ formatDateToTimestamp(fromDate, 'from') | trDateFormat: 'MMM D, y':timezone }} to {{ formatDateToTimestamp(toDate, 'to') | trDateFormat: 'MMM D, y':timezone }}
</h1>

<div class="row">
  <div class="col-xs-12 col-sm-4 mb-2">
    <div class="card">
      <div class="card-header lead secondary">
        Averages
      </div>
      <ul class="list-group list-group-flush">
        <li class="list-group-item">
          <span class="">Wait time:</span> {{ metrics.avgWait }} minutes
        </li>
        <li class="list-group-item">
          <span class="">{{ labels?.customer | titlecase }} response time:</span> {{ metrics.avgResponseTime }} minutes
        </li>
        <li class="list-group-item" *ngIf="size">
          <span class="">Size:</span>
          {{ metrics.avgSize | number: '1.1-1' }}
        </li>
        <li class="list-group-item">
          <span class="">Turn time:</span>
          {{ metrics.avgTurnTime }} minutes
        </li>
      </ul>
    </div>
  </div>

  <div class="col-xs-12 col-sm-4 mb-2">
    <div class="card">
      <div class="card-header lead secondary">
        Totals
      </div>
      <ul class="list-group list-group-flush">
        <li class="list-group-item">
          <span class="">{{ labels?.customer_plural | titlecase }} served:</span> {{ metrics.totalParties }}
        </li>
        <li class="list-group-item" *ngIf="size">
          <span class="">Total quantity served:</span> {{ metrics.totalCustomers }}
        </li>
        <li class="list-group-item">
          <span class="">{{ labels?.customer_plural | titlecase }} canceled:</span>
          {{ metrics.totalCancels }}
        </li>
        <li class="list-group-item">
          <span class="">Texts sent:</span>
          {{ metrics.totalSms }}
        </li>
        <li class="list-group-item">
          <span class="">Texts received:</span>
          {{ metrics.totalInbound }}
        </li>
        <li class="list-group-item">
          <span class="">Calls made:</span>
          {{ metrics.totalVoice }}
        </li>
      </ul>
    </div>
  </div>

  <div class="col-xs-12 col-sm-4 mb-2">
    <div class="card">
      <div class="card-header lead secondary">
        Percentages
      </div>
      <ul class="list-group list-group-flush">
        <li class="list-group-item">
          <span class="">Served on-time:</span> {{ metrics.pctOnTime | number: '1.0-0'}}%
        </li>
        <li class="list-group-item">
          <span class="">Canceled {{ labels?.customer_plural | titlecase }}:</span> {{ metrics.pctCanceled | number: '1.0-0' }}%
        </li>
      </ul>
    </div>
  </div>
</div>
